// extracted by mini-css-extract-plugin
export default {"loading":"styles_loading__gmDZ+","loaderBox":"styles_loaderBox__Gx2g0","loader":"styles_loader__RiiHN","rotate":"styles_rotate__mZZR3"};